import { render, staticRenderFns } from "./workplaceComponent.vue?vue&type=template&id=6283aa14&scoped=true"
import script from "./workplaceComponent.vue?vue&type=script&lang=js"
export * from "./workplaceComponent.vue?vue&type=script&lang=js"
import style0 from "./workplaceComponent.vue?vue&type=style&index=0&id=6283aa14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6283aa14",
  null
  
)

export default component.exports